(function () {
  var TOTAL_STEPS = 3;
  var answers = {};
  var currentStep = 1;

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }

  /* ---- Recipient to occasion mapping ---- */
  var OCCASION_MAP = {
    wife:      ['birthday','anniversary','eid','wedding','valentine','sorry','surprise','getwellsoon','congratulations'],
    husband:   ['birthday','anniversary','eid','wedding','valentine','sorry','surprise','graduation','thankyou','getwellsoon','congratulations'],
    sister:    ['birthday','anniversary','eid','wedding','surprise','graduation','getwellsoon','congratulations'],
    brother:   ['birthday','anniversary','graduation','eid','wedding','thankyou','getwellsoon','congratulations'],
    mum:       ['birthday','anniversary','eid','surprise','getwellsoon','congratulations'],
    dad:       ['birthday','anniversary','graduation','eid','surprise','thankyou','congratulations'],
    friendher: ['birthday','anniversary','eid','wedding','surprise','thankyou','getwellsoon','congratulations'],
    friendhim: ['birthday','graduation','eid','surprise','corporate','thankyou','congratulations'],
    colleague: ['birthday','eid','surprise','corporate','thankyou','congratulations'],
    couple:    ['birthday','anniversary','eid','wedding','valentine','sorry','surprise','graduation','thankyou','getwellsoon','congratulations'],
    newborn:   ['newborn','birthday','eid','surprise','congratulations']
  };

  function filterOccasions(recipient) {
    var allowed = OCCASION_MAP[recipient] || null;
    $$('[data-group="occasion"] .gf__opt').forEach(function (opt) {
      var visible = !allowed || allowed.indexOf(opt.dataset.value) !== -1;
      opt.style.display = visible ? '' : 'none';
      if (!visible) opt.classList.remove('is-selected');
    });
  }

  function resetOccasions() {
    $$('[data-group="occasion"] .gf__opt').forEach(function (opt) {
      opt.style.display = '';
    });
  }

  function goStep(n) {
    $$('.gf__step').forEach(function (el) { el.classList.remove('is-active'); });
    var target = document.querySelector('[data-step="' + n + '"]');
    if (target) {
      target.classList.add('is-active');
      currentStep = n;
      updateProgress();
      var section = document.querySelector('.gf');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function updateProgress() {
    var pct = Math.round((currentStep / TOTAL_STEPS) * 100);
    $('#gfProgressFill').style.width = pct + '%';
    $('#gfProgressText').textContent = 'Step ' + currentStep + ' of ' + TOTAL_STEPS;
    $('#gfProgressPct').textContent = pct + '%';
  }

  /* ---- Option selection, auto-advance ---- */
  $$('.gf__opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var group = this.closest('[data-group]').dataset.group;
      var siblings = this.closest('[data-group]').querySelectorAll('.gf__opt');
      siblings.forEach(function (s) { s.classList.remove('is-selected'); });
      this.classList.add('is-selected');
      answers[group] = {
        value: this.dataset.value,
        collection: this.dataset.collection || null,
        fetch: this.dataset.fetch || this.dataset.collection || null,
        min: this.dataset.min ? parseInt(this.dataset.min) : null,
        max: this.dataset.max ? parseInt(this.dataset.max) : null
      };
      if (group === 'recipient') {
        filterOccasions(this.dataset.value);
      }
      var step = parseInt(this.closest('.gf__step').dataset.step);
      setTimeout(function () {
        if (step < TOTAL_STEPS) {
          goStep(step + 1);
        } else {
          showResults();
        }
      }, 220);
    });
  });

  /* ---- Back buttons ---- */
  $$('[data-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var prev = parseInt(this.dataset.prev);
      if (prev > 0) goStep(prev);
    });
  });

  $('#gfRestart').addEventListener('click', function () {
    answers = {};
    $$('.gf__opt').forEach(function (o) { o.classList.remove('is-selected'); });
    resetOccasions();
    $('#gfResults').classList.remove('is-active');
    $('#gfProgress').style.display = '';
    goStep(1);
  });


  /* ---- Recipient + Occasion combination → best collection to fetch ---- */
  var COMBO_MAP = {
    'wife|birthday':         { fetch: '/collections/flowers',    viewAll: '/collections/birthday-gifts' },
    'wife|anniversary':      { fetch: '/collections/rose-bouquets',      viewAll: '/collections/anniversary-gifts' },
    'wife|valentine':        { fetch: '/collections/rose-bouquets',      viewAll: '/collections/love-romantic' },
    'wife|sorry':            { fetch: '/collections/rose-bouquets',      viewAll: '/collections/sorry-gifts' },
    'wife|eid':              { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'wife|wedding':          { fetch: '/collections/engagement-wedding', viewAll: '/collections/engagement-wedding' },
    'wife|surprise':         { fetch: '/collections/flowers',    viewAll: '/collections/surprise-gifts' },
    'wife|getwellsoon':      { fetch: '/collections/flowers',    viewAll: '/collections/get-well-soon-gifts' },
    'wife|congratulations':  { fetch: '/collections/flowers',    viewAll: '/collections/congratulations' },

    'husband|birthday':      { fetch: '/collections/gifts-for-husband',         viewAll: '/collections/birthday-gifts' },
    'husband|anniversary':   { fetch: '/collections/gift-hampers',       viewAll: '/collections/anniversary-gifts' },
    'husband|valentine':     { fetch: '/collections/gifts-for-husband',         viewAll: '/collections/love-romantic' },
    'husband|sorry':         { fetch: '/collections/sorry-gifts',       viewAll: '/collections/sorry-gifts' },
    'husband|eid':           { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'husband|wedding':       { fetch: '/collections/gift-hampers',       viewAll: '/collections/engagement-wedding' },
    'husband|graduation':    { fetch: '/collections/gifts-for-husband',         viewAll: '/collections/congratulations' },
    'husband|surprise':      { fetch: '/collections/gifts-for-husband',         viewAll: '/collections/surprise-gifts' },
    'husband|thankyou':      { fetch: '/collections/thank-you-gifts',       viewAll: '/collections/thank-you-gifts' },
    'husband|congratulations':{ fetch: '/collections/gifts-for-husband',        viewAll: '/collections/congratulations' },

    'mum|birthday':          { fetch: '/collections/flowers',    viewAll: '/collections/birthday-gifts' },
    'mum|anniversary':       { fetch: '/collections/flowers',    viewAll: '/collections/anniversary-gifts' },
    'mum|eid':               { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'mum|surprise':          { fetch: '/collections/flowers',    viewAll: '/collections/surprise-gifts' },
    'mum|getwellsoon':       { fetch: '/collections/flowers',    viewAll: '/collections/get-well-soon-gifts' },
    'mum|congratulations':   { fetch: '/collections/flowers',    viewAll: '/collections/congratulations' },

    'dad|birthday':          { fetch: '/collections/gifts-for-him',         viewAll: '/collections/birthday-gifts' },
    'dad|anniversary':       { fetch: '/collections/gift-hampers',       viewAll: '/collections/anniversary-gifts' },
    'dad|eid':               { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'dad|graduation':        { fetch: '/collections/gifts-for-him',         viewAll: '/collections/congratulations' },
    'dad|surprise':          { fetch: '/collections/gifts-for-him',         viewAll: '/collections/surprise-gifts' },
    'dad|thankyou':          { fetch: '/collections/thank-you-gifts',       viewAll: '/collections/thank-you-gifts' },
    'dad|congratulations':   { fetch: '/collections/gifts-for-him',         viewAll: '/collections/congratulations' },

    'sister|birthday':       { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/birthday-gifts' },
    'sister|anniversary':    { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/anniversary-gifts' },
    'sister|eid':            { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/eid-gifts' },
    'sister|wedding':        { fetch: '/collections/engagement-wedding', viewAll: '/collections/engagement-wedding' },
    'sister|graduation':     { fetch: '/collections/gift-hampers',       viewAll: '/collections/congratulations' },
    'sister|surprise':       { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/surprise-gifts' },
    'sister|getwellsoon':    { fetch: '/collections/flowers',    viewAll: '/collections/get-well-soon-gifts' },
    'sister|congratulations':{ fetch: '/collections/gift-hampers',       viewAll: '/collections/congratulations' },

    'brother|birthday':      { fetch: '/collections/gifts-for-him',         viewAll: '/collections/birthday-gifts' },
    'brother|graduation':    { fetch: '/collections/gifts-for-him',         viewAll: '/collections/congratulations' },
    'brother|eid':           { fetch: '/collections/gifts-for-him',         viewAll: '/collections/eid-gifts' },
    'brother|wedding':       { fetch: '/collections/gift-hampers',       viewAll: '/collections/engagement-wedding' },
    'brother|thankyou':      { fetch: '/collections/gifts-for-him',         viewAll: '/collections/thank-you-gifts' },
    'brother|congratulations':{ fetch: '/collections/gifts-for-him',        viewAll: '/collections/congratulations' },
    'brother|surprise':      { fetch: '/collections/gifts-for-him',         viewAll: '/collections/surprise-gifts' },

    'friendher|birthday':    { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/birthday-gifts' },
    'friendher|eid':         { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/eid-gifts' },
    'friendher|wedding':     { fetch: '/collections/engagement-wedding', viewAll: '/collections/engagement-wedding' },
    'friendher|surprise':    { fetch: '/collections/gifts-for-girls',    viewAll: '/collections/surprise-gifts' },
    'friendher|thankyou':    { fetch: '/collections/thank-you-gifts',       viewAll: '/collections/thank-you-gifts' },
    'friendher|getwellsoon': { fetch: '/collections/flowers',    viewAll: '/collections/get-well-soon-gifts' },
    'friendher|congratulations':{ fetch: '/collections/gifts-for-girls', viewAll: '/collections/congratulations' },

    'friendhim|birthday':    { fetch: '/collections/gifts-for-him',         viewAll: '/collections/birthday-gifts' },
    'friendhim|graduation':  { fetch: '/collections/gifts-for-him',         viewAll: '/collections/congratulations' },
    'friendhim|eid':         { fetch: '/collections/gifts-for-him',         viewAll: '/collections/eid-gifts' },
    'friendhim|surprise':    { fetch: '/collections/gifts-for-him',         viewAll: '/collections/surprise-gifts' },
    'friendhim|corporate':   { fetch: '/collections/gift-hampers',       viewAll: '/collections/gift-hampers' },
    'friendhim|thankyou':    { fetch: '/collections/gifts-for-him',         viewAll: '/collections/thank-you-gifts' },
    'friendhim|congratulations':{ fetch: '/collections/gifts-for-him',      viewAll: '/collections/congratulations' },

    'colleague|birthday':    { fetch: '/collections/gift-hampers',       viewAll: '/collections/birthday-gifts' },
    'colleague|eid':         { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'colleague|corporate':   { fetch: '/collections/gift-hampers',       viewAll: '/collections/gift-hampers' },
    'colleague|thankyou':    { fetch: '/collections/thank-you-gifts',       viewAll: '/collections/thank-you-gifts' },
    'colleague|congratulations':{ fetch: '/collections/gift-hampers',    viewAll: '/collections/congratulations' },
    'colleague|surprise':    { fetch: '/collections/gift-hampers',       viewAll: '/collections/surprise-gifts' },

    'couple|wedding':        { fetch: '/collections/engagement-wedding', viewAll: '/collections/engagement-wedding' },
    'couple|anniversary':    { fetch: '/collections/gift-hampers',       viewAll: '/collections/anniversary-gifts' },
    'couple|birthday':       { fetch: '/collections/gift-hampers',       viewAll: '/collections/birthday-gifts' },
    'couple|eid':            { fetch: '/collections/gift-hampers',       viewAll: '/collections/eid-gifts' },
    'couple|valentine':      { fetch: '/collections/love-romantic',      viewAll: '/collections/love-romantic' },
    'couple|sorry':          { fetch: '/collections/flowers',    viewAll: '/collections/sorry-gifts' },
    'couple|surprise':       { fetch: '/collections/gift-hampers',       viewAll: '/collections/surprise-gifts' },
    'couple|congratulations':{ fetch: '/collections/gift-hampers',       viewAll: '/collections/congratulations' },

    'newborn|newborn':       { fetch: '/collections/newborn-baby-gifts', viewAll: '/collections/newborn-baby-gifts' },
    'newborn|birthday':      { fetch: '/collections/newborn-baby-gifts', viewAll: '/collections/birthday-gifts' },
    'newborn|eid':           { fetch: '/collections/newborn-baby-gifts', viewAll: '/collections/eid-gifts' },
    'newborn|surprise':      { fetch: '/collections/newborn-baby-gifts', viewAll: '/collections/surprise-gifts' },
    'newborn|congratulations':{ fetch: '/collections/newborn-baby-gifts',viewAll: '/collections/congratulations' }
  };

  /* ---- Recipient-specific collections (who the gift is for) ---- */
  var RECIPIENT_COLL = {
    wife:      '/collections/gifts-for-wife',
    husband:   '/collections/gifts-for-husband',
    sister:    '/collections/gifts-for-girls',
    brother:   '/collections/gifts-for-him',
    mum:       '/collections/mothers-day',  /* 13 Oct 2026: was gifts-for-wife, romantic stock for a mother */
    dad:       '/collections/gifts-for-him',
    friendher: '/collections/gifts-for-girls',
    friendhim: '/collections/gifts-for-him',
    colleague: '/collections/gift-hampers',
    couple:    '/collections/love-romantic',
    newborn:   '/collections/newborn-baby-gifts'
  };

  /* Occasions where the occasion itself defines the product (an Eid hamper is an
     Eid hamper regardless of who it is for). For the rest, the recipient matters
     more and the occasion is just context. */
  var STRONG_OCCASIONS = {
    eid: 1, graduation: 1, congratulations: 1, wedding: 1,
    newborn: 1, valentine: 1, anniversary: 1, corporate: 1
  };

  /* Second gender signal. Collection membership alone is not enough because
     plenty of obviously feminine products were never filed under a girls'
     collection, so they leak into results for brothers and dads when men's
     stock runs thin. These patterns are a backstop, not the primary rule. */
  var MALE_RECIPIENTS   = { husband: 1, brother: 1, dad: 1, friendhim: 1 };
  var FEMALE_RECIPIENTS = { wife: 1, sister: 1, mum: 1, friendher: 1 };
  // No trailing \b, these are prefixes ("accessor" must match "accessories").
  var FEMININE_WORDS = /\b(ladies|lady|princess|hello kitty|my melody|kuromi|barbie|bridal|bride|dulhan|heel|handbag|clutch|bangle|earring|necklace|jewel|makeup|cosmetic|beauty|nail polish|pastel|floral basket|for her|girlfriend|for wife|for sister|for mom|for mother|daughter|unicorn|mehndi|plush bouquet|blush)/i;
  var MASCULINE_WORDS = /\b(men'?s|mens|moustache|beard|grooming|for him|for husband|for brother|for father|for dad|papa|boyfriend)/i;

  // Romantic gifts are wrong for a sibling, parent, friend or colleague unless
  // the occasion itself is romantic.
  var NON_PARTNER = { brother: 1, dad: 1, sister: 1, mum: 1, friendher: 1, friendhim: 1, colleague: 1, newborn: 1 };
  var ROMANTIC_OCCASIONS = { valentine: 1, anniversary: 1, wedding: 1, sorry: 1 };
  var ROMANTIC_WORDS = /\b(couple|i love you|love you|my love|romantic|valentine|proposal|forever rose|engagement ring|anniversary)/i;

  /* When we top up results from an occasion collection, don't hand someone
     shopping for their brother a "Princess" or "Hello Kitty" gift. Collection
     membership is the primary gender signal. */
  var OPPOSITE_COLL = {
    husband:   ['/collections/gifts-for-girls', '/collections/gifts-for-wife'],
    brother:   ['/collections/gifts-for-girls', '/collections/gifts-for-wife'],
    dad:       ['/collections/gifts-for-girls', '/collections/gifts-for-wife'],
    friendhim: ['/collections/gifts-for-girls', '/collections/gifts-for-wife'],
    wife:      ['/collections/gifts-for-him', '/collections/gifts-for-husband'],
    sister:    ['/collections/gifts-for-him', '/collections/gifts-for-husband'],
    mum:       ['/collections/gifts-for-him', '/collections/gifts-for-husband'],
    friendher: ['/collections/gifts-for-him', '/collections/gifts-for-husband']
  };

  /* ---- Results ---- */
  function getCollections() {
    var rec = answers.recipient ? answers.recipient.value : null;
    var occ = answers.occasion  ? answers.occasion.value  : null;

    // Combined lookup, recipient + occasion gives the most relevant collection
    if (rec && occ && COMBO_MAP[rec + '|' + occ]) {
      return COMBO_MAP[rec + '|' + occ];
    }

    // Fall back: occasion overrides recipient (more specific than recipient alone)
    var viewAll = '/collections/all';
    var fetch   = '/collections/all';
    if (answers.recipient && answers.recipient.collection) {
      viewAll = answers.recipient.collection;
      fetch   = answers.recipient.fetch || answers.recipient.collection;
    }
    if (answers.occasion && answers.occasion.collection) {
      viewAll = answers.occasion.collection;
      fetch   = answers.occasion.fetch || answers.occasion.collection;
    }
    return { viewAll: viewAll, fetch: fetch };
  }

  function showResults() {
    /* SMG_TRACK1013 */
    try {
      if (window.smgTrack) window.smgTrack('quiz_complete', {
        recipient: answers.recipient ? answers.recipient.value : '',
        occasion: answers.occasion ? answers.occasion.value : '',
        budget: answers.budget ? answers.budget.value : ''
      });
    } catch (e) {}
    var colls = getCollections();
    var budgetMin = (answers.budget && answers.budget.min != null) ? answers.budget.min : null;
    var budgetMax = (answers.budget && answers.budget.max) ? answers.budget.max : null;

    $('#gfViewAll').href = colls.viewAll;
    $('#gfResultsSub').textContent = buildResultSub();

    var grid = $('#gfResultsGrid');
    grid.innerHTML = '<div style="text-align:center;padding:48px 0;color:var(--smg-muted);font-size:14px;">Finding the perfect gifts for you...</div>';

    // Show results panel immediately with loading state
    $$('.gf__step').forEach(function (el) { el.classList.remove('is-active'); });
    $('#gfResults').classList.add('is-active');
    $('#gfProgress').style.display = 'none';
    document.querySelector('.gf').scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Build the candidate pool from BOTH the recipient's collection and the
    // occasion's collection. Products that appear in both are the best match
    // (e.g. "Congratulations Achievement Gift Basket for Sister" is in both
    // gifts-for-girls and congratulations), so they rank first.
    var recVal      = answers.recipient ? answers.recipient.value : null;
    var occVal      = answers.occasion  ? answers.occasion.value  : null;
    var recColl     = RECIPIENT_COLL[recVal] || null;
    var occColl     = (answers.occasion && answers.occasion.collection) || null;
    var occIsStrong = occVal && STRONG_OCCASIONS[occVal];

    function loadColl(path) {
      if (!path) return Promise.resolve([]);
      return fetch(path + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }

    var oppositeColls = OPPOSITE_COLL[recVal] || [];

    // Curated "Gift For" / "Perfect For" values from each product's metafields.
    // This is the authoritative signal; collection membership and the keyword
    // patterns below are only fallbacks for products with no curated data.
    function loadGiftIndex() {
      if (window.__smgGiftIndex) return Promise.resolve(window.__smgGiftIndex);
      return fetch('https://admin.sendmygift.pk/api/gift-index')
        .then(function (r) { return r.ok ? r.json() : { products: {} }; })
        .then(function (d) { window.__smgGiftIndex = d.products || {}; return window.__smgGiftIndex; })
        .catch(function () { return {}; });
    }

    Promise.all([
      loadColl(recColl), loadColl(occColl), loadColl(colls.fetch), loadGiftIndex()
    ].concat(oppositeColls.map(loadColl)))
      .then(function (sets) {
        var recProducts = sets[0], occProducts = sets[1], comboProducts = sets[2];
        var giftIndex = sets[3] || {};
        sets = sets.slice(0, 3).concat(sets.slice(4)); // keep opposite-collection sets aligned

        // Anything belonging to the opposite gender's collection, unless it is
        // also in this recipient's own collection (some gifts suit both).
        var inRec = {}; recProducts.forEach(function (p) { inRec[p.id] = true; });
        var isOpposite = {};
        sets.slice(3).forEach(function (list) {
          list.forEach(function (p) { if (!inRec[p.id]) isOpposite[p.id] = true; });
        });

        // Keyword backstop for products never filed under a gendered collection.
        var wrongGenderWords = MALE_RECIPIENTS[recVal]   ? FEMININE_WORDS
                             : FEMALE_RECIPIENTS[recVal] ? MASCULINE_WORDS
                             : null;
        var blockRomantic = NON_PARTNER[recVal] && !ROMANTIC_OCCASIONS[occVal];
        var wantMale   = !!MALE_RECIPIENTS[recVal];
        var wantFemale = !!FEMALE_RECIPIENTS[recVal];

        function genderOk(p) {
          var title = p.title || '';
          if (blockRomantic && ROMANTIC_WORDS.test(title)) return false;

          // Curated metafield data wins when we have it.
          var meta = giftIndex[p.id];
          if (meta && (meta.m || meta.f)) {
            if (wantMale   && meta.f && !meta.m) return false;  // tagged for her only
            if (wantFemale && meta.m && !meta.f) return false;  // tagged for him only
            return true;
          }

          if (!wrongGenderWords) return true;
          if (inRec[p.id]) return true;           // already in this recipient's own collection
          return !wrongGenderWords.test(title);
        }
        function allowed(p) { return !isOpposite[p.id] && genderOk(p); }

        // Prefer products the team explicitly marked as right for this occasion.
        function occasionRank(p) {
          var meta = giftIndex[p.id];
          return (meta && meta.o && meta.o.indexOf(occVal) !== -1) ? 0 : 1;
        }
        // Advance booking stock (tag 'advance booking', the 6/12/24 imported roses) goes
        // after same day gifts in every tier, so the local same day red rose
        // bouquets surface before the imported ones (Oct 2026).
        function advanceRank(p) {
          var t = p.tags || [];
          if (typeof t === 'string') t = t.split(',');
          for (var i = 0; i < t.length; i++) {
            if (/^\s*advance booking\s*$/i.test(t[i])) return 1;
          }
          return 0;
        }
        function byOccasion(list) {
          return list.slice().sort(function (a, b) {
            return (advanceRank(a) - advanceRank(b)) || (occasionRank(a) - occasionRank(b));
          });
        }
        var comboSorted = comboProducts.slice().sort(function (a, b) { return advanceRank(a) - advanceRank(b); });

        // 1. products in both  2. the dominant side  3. the other side  4. combo map
        // Within each tier, products the team marked as right for this occasion
        // are shown first.
        var both      = byOccasion(occProducts.filter(function (p) { return inRec[p.id]; }));
        var primary   = byOccasion(occIsStrong ? occProducts : recProducts);
        var secondary = byOccasion(occIsStrong ? recProducts : occProducts);

        var allProducts = [], seenId = {};
        [both, primary, secondary, comboSorted].forEach(function (list) {
          list.filter(allowed).forEach(function (p) {
            if (!seenId[p.id]) { seenId[p.id] = true; allProducts.push(p); }
          });
        });
        // Relax in stages so we never show an empty result, but keep the gender
        // guard as long as possible: first allow items that are only excluded by
        // collection membership, and drop the keyword guard last.
        function topUp(test) {
          [both, primary, secondary, comboSorted].forEach(function (list) {
            list.forEach(function (p) {
              if (!seenId[p.id] && test(p)) { seenId[p.id] = true; allProducts.push(p); }
            });
          });
        }
        if (allProducts.length < 3) topUp(genderOk);
        if (allProducts.length < 3) topUp(function () { return true; });
        if (!allProducts.length) allProducts = comboProducts;

        var products = allProducts;

        function priceOf(p) {
          return (p.variants && p.variants[0]) ? parseFloat(p.variants[0].price) : null;
        }

        // Owner rule 6 Oct 2026: the minimum order is Rs 4,999, so a non cake
        // gift under the feature minimum can never be suggested, not even as a
        // filler. Cakes are exempt. The minimum comes from the section setting.
        var gfEl = document.querySelector('.gf[data-feature-min]');
        var featureMin = gfEl ? parseInt(gfEl.dataset.featureMin, 10) : 5000;
        if (isNaN(featureMin)) featureMin = 5000;
        function isCake(p) { return /cake/i.test(p.product_type || ''); }
        function floorOk(p) {
          var price = priceOf(p);
          return price !== null && (price >= featureMin || isCake(p));
        }

        // Apply budget range filter
        if (budgetMax || budgetMin) {
          products = allProducts.filter(function (p) {
            var price = priceOf(p);
            if (price === null) return false;
            if (budgetMin !== null && price < budgetMin) return false;
            if (budgetMax && price > budgetMax) return false;
            return floorOk(p);
          });

          // Too few in this price band, stay in the right collection and top up
          // with the closest-priced gifts rather than showing a near-empty result
          // or dropping to generic category tiles.
          if (products.length < 6) {
            var exactCount = products.length;
            var target = (budgetMin !== null && budgetMax)
              ? (budgetMin + Math.min(budgetMax, budgetMin * 3)) / 2
              : (budgetMax || budgetMin);
            var chosen = products.slice();
            var seen = {};
            chosen.forEach(function (p) { seen[p.id] = true; });

            allProducts
              .filter(function (p) { return floorOk(p) && !seen[p.id]; })
              .sort(function (a, b) {
                return Math.abs(priceOf(a) - target) - Math.abs(priceOf(b) - target);
              })
              .forEach(function (p) { if (chosen.length < 6) chosen.push(p); });

            products = chosen;
            // Only flag it when the price match is genuinely poor, topping a
            // 4-item band up to 6 does not need an apology.
            if (products.length > exactCount && exactCount < 3) {
              $('#gfResultsSub').textContent = exactCount === 0
                ? 'We had nothing in that exact price range, so here are the closest matches.'
                : 'Only a few match that price range exactly, so we added the closest matches too.';
            }
          }
        } else {
          products = allProducts.filter(floorOk);
        }

        /* Any Budget (13 Oct 2026): show the whole range, not just the top six.
           The Rs 5,000 floor for non cake gifts still applies (floorOk above).
           Pick round robin across the price bands in match order so every band
           is represented, then list cheapest first so the range reads clearly. */
        var anyBudget = answers.budget && answers.budget.value === 'any';
        if (anyBudget) {
          var bands = [[], [], [], []];
          products.forEach(function (p) {
            var pr = priceOf(p);
            var b = pr <= 8000 ? 0 : pr <= 12000 ? 1 : pr <= 15000 ? 2 : 3;
            bands[b].push(p);
          });
          var mixed = [];
          for (var r = 0; mixed.length < 12 && r < 12; r++) {
            for (var bi = 0; bi < 4 && mixed.length < 12; bi++) { if (bands[bi][r]) mixed.push(bands[bi][r]); }
          }
          products = mixed.sort(function (a, b) { return priceOf(a) - priceOf(b); });
          $('#gfResultsSub').textContent = buildResultSub() + ' Showing gifts at every price, lowest first.';
        }

        products = products.slice(0, anyBudget ? 12 : 6);

        if (products.length > 0) {
          grid.innerHTML = products.map(function (p) {
            var img = (p.images && p.images[0]) ? p.images[0].src : '';
            var price = (p.variants && p.variants[0])
              ? 'Rs. ' + Math.round(parseFloat(p.variants[0].price)).toLocaleString()
              : '';
            var safeTitle = (p.title || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
            return '<a href="/products/' + p.handle + '" class="gf__result-card">' +
              (img
                ? '<img class="gf__result-img" src="' + img + '" alt="' + safeTitle + '" loading="lazy">'
                : '<div style="background:var(--smg-blush);height:160px;display:flex;align-items:center;justify-content:center;font-size:56px;">🎁</div>') +
              '<div class="gf__result-info">' +
                '<div class="gf__result-name">' + (p.title || '') + '</div>' +
                '<div class="gf__result-price">' + price + '</div>' +
              '</div></a>';
          }).join('');
        } else {
          grid.innerHTML = buildFallbackCards();
          $('#gfViewAll').href = '/collections/all';
        }
      })
      .catch(function () {
        grid.innerHTML = buildFallbackCards();
      });
  }

  function buildFallbackCards() {
    var fallback = [
      { label: 'Birthday Gifts', url: '/collections/birthday-gifts', emoji: '🎂' },
      { label: 'Anniversary Gifts', url: '/collections/anniversary-gifts', emoji: '💍' },
      { label: 'Love & Romantic', url: '/collections/love-romantic', emoji: '❤️' },
      { label: 'Surprise Gifts', url: '/collections/surprise-gifts', emoji: '🎀' },
    ];
    return fallback.map(function (c) {
      return '<a href="' + c.url + '" class="gf__result-card">' +
        '<div style="background:var(--smg-blush);height:160px;display:flex;align-items:center;justify-content:center;font-size:56px;">' + c.emoji + '</div>' +
        '<div class="gf__result-info">' +
          '<div class="gf__result-name">' + c.label + '</div>' +
          '<div class="gf__result-price">Browse collection →</div>' +
        '</div></a>';
    }).join('');
  }

  function buildResultSub() {
    var occ = answers.occasion ? answers.occasion.value : '';
    var rec = answers.recipient ? answers.recipient.value : '';
    var occMap = {
      birthday: 'their birthday', anniversary: 'your anniversary', eid: 'Eid',
      wedding: 'the engagement or wedding', valentine: "Valentine's Day", surprise: 'a lovely surprise',
      newborn: 'the new arrival', corporate: 'corporate gifting',
      graduation: 'their graduation / special occasion', thankyou: 'a thank you', getwellsoon: 'wishing them well',
      congratulations: 'congratulating them'
    };
    var recMap = {
      wife: 'her', husband: 'him',
      sister: 'her', brother: 'him',
      mum: 'your mum', dad: 'your dad',
      friendher: 'your friend', friendhim: 'your friend',
      colleague: 'your colleague',
      newborn: 'the little one', couple: 'the couple'
    };
    var occLabel = occMap[occ] || 'the occasion';
    var recLabel = recMap[rec] || 'them';
    return 'Here are our best picks for ' + recLabel + ' on ' + occLabel + '.';
  }
})();
